import { render } from "./VabChartScatter.vue?vue&type=template&id=218a374c"
import script from "./VabChartScatter.vue?vue&type=script&lang=js"
export * from "./VabChartScatter.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/other/echarts/components/VabChartScatter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "218a374c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('218a374c', __exports__)) {
    console.log('reload')
    api.reload('218a374c', __exports__)
  }
  
  module.hot.accept("./VabChartScatter.vue?vue&type=template&id=218a374c", () => {
    console.log('re-render')
    api.rerender('218a374c', render)
  })

}


export default __exports__